export default __webpack_public_path__ + "ae6927dc7636a08704889ca9a83870b8.png";